// Form Configuration Schema for Noorderkempen Form
// This JSON structure defines the complete form layout, fields, validation, and styling

export const noorderkempenFormConfig = {
  // Form metadata
  metadata: {
    title: "Aanmelding ILV Noorderkempen",
    description: "Vul hier de aanmeldgegevens in",
    defDossier: 5115,
    apiUsername: "API_NOORDERKEMPEN_USERNAME",
    apiKey: "API_NOORDERKEMPEN_KEY",
    brandColors: {
      primary: "#2d5a3d",
      primaryLight: "#4a7c59",
      primaryDark: "#1a3d26",
      accent: "#66bb6a",
      neutral: "#f8f9fa",
      text: "#212529",
      textLight: "#6c757d",
      border: "#e9ecef"
    }
  },

  // Form sections with layout and styling
  sections: [
    {
      id: "basic-info",
      title: "Aanmeldingsgegevens",
      description: "Vul alle velden zorgvuldig in om je aanvraag te voltooien",
      order: 1,
      layout: {
        columns: { default: 1, md: 2, lg: 3 },
        gap: "gap-6"
      },
      fields: [
        {
          id: "registration-date",
          name: "102255",
          type: "date",
          label: "Datum aanmelding",
          required: true,
          columnSpan: { default: 1, md: 1, lg: 1 },
          validation: {
            required: "Dit veld is verplicht",
          }
        },

        {
          id: "Gegevens-doorverwijzer",
          name: "126192",
          type: "text",
          label: "Gegevens doorverwijzer/ aanmelder ",
          required: true,
          columnSpan: { default: 2, md: 2, lg: 3 },
          validation: {}
        },


      ]
    },
    {
      id: "personal-info",
      title: "Persoonsgegevens",
      description: "Gegevens van de persoon voor wie de aanvraag wordt ingediend",
      order: 2,
      layout: {
        columns: { default: 1 },
        gap: "gap-6"
      },

      linkedContainer: {
        displayId: "107146",
        defdossierId: 5329,
      },
      fields: [
        {
          id: "first-name",
          name: "107126",
          type: "text",
          label: "Voornaam",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht",
            pattern: { value: /^[a-zA-Z\s]+$/, message: "Alleen letters toegestaan" }
          }
        },
        {
          id: "middle-name",
          name: "107132",
          type: "text",
          label: "Tussenvoegsel",
          required: false,
          columnSpan: { default: 1 },
          validation: {}
        },
        {
          id: "last-name",
          name: "107130",
          type: "text",
          label: "Achternaam",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht",
            pattern: { value: /^[a-zA-Z\s]+$/, message: "Alleen letters toegestaan" }
          }
        },
        {
          id: "phone",
          name: "107139",
          type: "phone",
          label: "Telefoon",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht",
            pattern: { value: /^[\d\s\-+()]+$/, message: "Ongeldig telefoonnummer" }
          }
        },
        {
          id: "email",
          name: "107138",
          type: "email",
          label: "Email",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Dit veld is verplicht",
            pattern: { value: /^\S+@\S+$/i, message: "Ongeldig emailadres" }
          }
        },
        {
          id: "gender",
          name: "107134",
          type: "select",
          label: "Geslacht",
          required: false,
          columnSpan: { default: 1 },
          options: [
            { value: "49972", label: "Onbekend" },
            { value: "49966", label: "Vrouw" },
            { value: "49960", label: "Man" }
          ],
          validation: {}
        },
        {
          id: "birth-date",
          name: "107136",
          type: "date",
          label: "Geboortedatum",
          required: false,
          columnSpan: { default: 1 },
          validation: {}
        },
        {
          id: "education-level",
          name: "107143",
          type: "select",
          label: "Opleidingsniveau",
          required: false,
          columnSpan: { default: 1 },
          options: [
            { value: "50212", label: "BUSO" },
            { value: "50211", label: "Niet bekend" },
            { value: "50210", label: "Hoog" },
            { value: "50209", label: "Midden" },
            { value: "50208", label: "Laaggeschoold" }
          ],
          validation: {}
        },
        {
          id: "national-registry-number",
          name: "107140",
          type: "number",
          label: "Rijksregisternummer",
          required: false,
          columnSpan: { default: 1 },
          validation: {}
        },
        {
          id: "housing",
          name: "107142",
          type: "select",
          label: "Huisvesting",
          required: false,
          columnSpan: { default: 1 },
          options: [
            { value: "50221", label: "Thuisloos" },
            { value: "50220", label: "Niet stabiel" },
            { value: "50219", label: "Dakloos" },
            { value: "50218", label: "Samenwonend" },
            { value: "50217", label: "Bij de ouders" },
            { value: "49793", label: "Alleenwonend" },
            { value: "49786", label: "Andere" }
          ],
          validation: {}
        },
        {
          id: "status",
          name: "107144",
          type: "select",
          label: "Statuut",
          required: false,
          columnSpan: { default: 1 },
          options: [
            { value: "50228", label: "Werkend" },
            { value: "50227", label: "Geen" },
            { value: "50226", label: "VAPH" },
            { value: "50225", label: "Leefloon" },
            { value: "50224", label: "RVA" },
            { value: "50223", label: "Ziekteuitkering" },
            { value: "50222", label: "FOD (IVT/IT)" }
          ],
          validation: {}
        }
      ]
    },
    {
      id: "additional",
      title: "",
      description: "",
      order: 3,
      layout: {
        columns: { default: 2 },
        gap: "gap-6"
      },
      fields: [
        {
          id: "participant-help-request",
          name: "107076",
          type: "textarea",
          label: "Hulpvraag deelnemer - beknopt",
          labelDescription: {
            text: "Welke hulpvraag stelt de deelnemer zelf? Rond welke zaken wil de deelnemer momenteel zelf ondersteuning?"
          },
          required: true,
          columnSpan: { default: 2, md: 2, lg: 3 },
          validation: {
            required: "Dit veld is verplicht",
          }
        },
        {
          id: "drempels",
          name: "126191",
          type: "select",
          label: "Drempels",
          required: false,
          multiSelect: true,
          columnSpan: { default: 1 },
          options: [
            { "value": 66425, "label": "Andere:..." },
            { "value": 66424, "label": "Beperkte fysieke zelfzorg" },
            { "value": 66423, "label": "Mantelzorg" },
            { "value": 66422, "label": "Geen sociaal netwerk" },
            { "value": 66421, "label": "Gebrek aan zelfstandigheid" },
            { "value": 66420, "label": "Beperkte mobiliteit" },
            { "value": 66419, "label": "Moedeloos" },
            { "value": 66418, "label": "Agressie" },
            { "value": 66417, "label": "Juridisch verleden" },
            { "value": 66416, "label": "Detentie verleden" },
            { "value": 66415, "label": "game/gok verslaving" },
            { "value": 66414, "label": "Drugs/alcohol verslaving" },
            { "value": 66413, "label": "Familiale problemen" },
            { "value": 66412, "label": "Familiaal geweld" },
            { "value": 66411, "label": "Lage zelfkennis" },
            { "value": 66410, "label": "Mentale beperking" },
            { "value": 66409, "label": "Psychische problematiek" },
            { "value": 66408, "label": "Fysieke beperking" },
            { "value": 66407, "label": "Fysiek probleem" },
            { "value": 66406, "label": "Huisdieren" },
            { "value": 66405, "label": "Verstoord dag-nachtritme" },
            { "value": 66404, "label": "Wachtlijsten bij juiste hulpverlening" },
            { "value": 66403, "label": "Analfabetisme" },
            { "value": 66402, "label": "Taalbarrière" },
            { "value": 66401, "label": "Nieuwkomer" },
            { "value": 66400, "label": "Cultuurkloof" },
            { "value": 66399, "label": "Geen kinderopvang" },
            { "value": 66398, "label": "Administratieve problemen" },
            { "value": 66397, "label": "Schooluitval" },
            { "value": 66396, "label": "Laaggeschoold" },
            { "value": 66395, "label": "Lage digitale vaardigheden" },
            { "value": 66394, "label": "Beperkte werkvaardigheden" },
            { "value": 66393, "label": "Geen werk" },
            { "value": 66392, "label": "Generatiearmoede" },
            { "value": 66391, "label": "Financiële onzekerheid" },
            { "value": 66390, "label": "schulden" },
            { "value": 61671, "label": "Slechte woonkwaliteit" },
            { "value": 61670, "label": "Geen vaste woonplaats" }
          ],
          validation: {}
        },
      ]
    },
    {
      id: "additional-info",
      title: "Aanvullende Informatie",
      description: "Extra informatie ter ondersteuning van de aanvraag",
      order: 4,
      layout: {
        columns: { default: 2 },
        gap: "gap-6"
      },
      fields: [
        {
          id: "referrer-explanation",
          name: "107077",
          type: "textarea",
          label: "Toelichting ",
          required: false,
          columnSpan: { default: 2, md: 2, lg: 2 },
          validation: {}
        }
      ]
    }
  ],

  // Progress tracking configuration
  progress: {
    enabled: true,
    trackRequiredFields: true
  },

  // Auto-save configuration
  autoSave: {
    enabled: false,
    delay: 1000, // milliseconds
    statusMessages: {
      saving: "Bezig met opslaan...",
      saved: "Automatisch opgeslagen",
      error: "Opslag mislukt"
    }
  },

  // Form submission configuration
  submission: {
    showSummary: true,
    summaryFields: [
      { label: "Voortgang", field: "progress" },
      { label: "Status", field: "status" }
    ],
    submitButton: {
      text: "Aanvraag Versturen",
      disabledText: "Vul alle velden in",
      requireAllRequired: true
    }
  },

  // Base styling configuration
  styling: {
    fonts: {
      primary: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      size: {
        small: "12px",
        base: "14px",
        large: "16px"
      }
    },
    spacing: {
      small: "8px",
      base: "12px",
      medium: "16px",
      large: "24px"
    },
    borderRadius: {
      small: "6px",
      base: "8px",
      large: "12px"
    },
    shadows: {
      small: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      medium: "0 4px 6px -1px",
      large: "0 8px 15px -3px"
    },
    transitions: {
      fast: "all 0.2s ease-in-out",
      medium: "all 0.3s ease-out"
    },

    // Component-specific styles
    label: {
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "1.4",
      marginTop: "0",
      marginBottom: "8px",
      textAlign: "left",
      letterSpacing: "0.025em",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    input: {
      display: "block",
      width: "100%",
      padding: "12px 16px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.5",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #c3c3c381",
      height: "48px",
      borderRadius: "8px",
      transition: "all 0.2s ease-in-out",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    textarea: {
      height: "120px",
      resize: "vertical",
      minHeight: "120px"
    },
    select: {
      control: {
        border: "1px solid #c3c3c381",
        borderRadius: "8px",
        minHeight: "48px",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
      },
      placeholder: {
        color: "#6b7280"
      },
      multiValue: {
        backgroundColor: "#e5e7eb",
        borderRadius: "4px"
      },
      multiValueLabel: {
        color: "#374151",
        fontSize: "14px"
      },
      multiValueRemove: {
        color: "#6b7280",
        ":hover": {
          backgroundColor: "#d1d5db",
          color: "#374151"
        }
      },
      valueContainer: {
        padding: "2px 8px"
      }
    },
    button: {
      background: "linear-gradient(135deg)",
      color: "white",
      fontWeight: "600",
      padding: "12px 24px",
      borderRadius: "8px",
      border: "none",
      fontSize: "14px",
      letterSpacing: "0.025em",
      transition: "all 0.2s ease-in-out",
      boxShadow: "0 4px 6px -1px",
      textTransform: "uppercase"
    }
  }
};

export default noorderkempenFormConfig;